import { HttpClient } from '#client/http/index'
import {
  ApiCreditCard,
  CreditCard,
  CreditCardToken,
  CreditCardCreateResponse,
  CreditCardId,
  ChargeType,
  ChargeCreditResponse,
  PaymentId,
  PurchaseHistoryResponse,
  IssueReceiptParams,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

const convertCreditCard = ({ cardId, ...rest }: ApiCreditCard): CreditCard => ({
  ...rest,
  id: cardId,
})

export const createCreditCard = (
  { httpClient }: { httpClient: HttpClient },
  token: CreditCardToken,
): Promise<CreditCardCreateResponse> =>
  httpClient.post('/user/payments/credit/card', {
    'payjp-token': token,
  })

export const destroyCreditCard = (
  { httpClient }: { httpClient: HttpClient },
  cardId: CreditCardId,
) => httpClient.delete(`/user/payments/credit/card/${cardId}`)

export const listCreditCard = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<ApiCreditCard[]> = await httpClient.get(
    '/user/payments/credit/card',
  )
  return data.map(convertCreditCard)
}

export const changeDefaultCreditCard = (
  { httpClient }: { httpClient: HttpClient },
  cardId: CreditCardId,
) => httpClient.put(`/user/payments/credit/card/default`, { cardId })

export const chargeCredit = async (
  { httpClient }: { httpClient: HttpClient },
  cardId: CreditCardId,
  price: number,
  chargeType: ChargeType = ChargeType.BULK,
) => {
  const { data }: ApiResponse<ChargeCreditResponse> = await httpClient.post(
    `/user/payments/credit/charge`,
    { cardId, price },
    { params: { type: chargeType } },
  )
  return data
}

export const refund = async (
  { httpClient }: { httpClient: HttpClient },
  paymentId: PaymentId,
) => await httpClient.delete(`/user/payments/refund/${paymentId}`)

export const listPurchaseLog = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<PurchaseHistoryResponse> = await httpClient.get(
    `/user/payments/purchase/log`,
  )
  return data
}

export const issueReceipt = async (
  { httpClient }: { httpClient: HttpClient },
  paymentId: PaymentId,
  params: IssueReceiptParams,
) => {
  await httpClient.post(`/user/payments/receipt/${paymentId}`, params)
}
